import { Button, TextField } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import avatar from '../../../img/logo-gmi.png';
import Select from 'react-select'
import CreatableSelect from 'react-select/creatable';
import BarChartRoundedIcon from '@material-ui/icons/Settings';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import TableGenerator from '../TableGenerator';
const useStyles = makeStyles((theme) => ({
  container: {},
  writing:
    { color: 'blue' },
  content: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center'
  },
  logo_position: {
    marginRight: 10,
    alignItems: 'left',
    flex: 1,
  },
  delete: {
    background: "#f1f1f1",
    color:'blue ',
    borderRadius:20,
    marginLeft: 10,
    '&:hover': {
      color:'white',
      background: "red",
    }
  },
  adding: {
    background: "#f1f1f1",
    borderRadius:20,
    color:'blue ',
    marginLeft: 10,
    '&:hover': {
      color:'white',
      background: "blue",
    }
  },
  delete: {
    background: "#f1f1f1",
    color: 'blue ',
    borderRadius: 20,
    marginLeft:'auto',
    marginRight:'auto',
    '&:hover': {
      color: 'blue',
      background: "#f1f1f1",
      cursor: 'pointer',
      boxShadow: '3px 3px 3px blue'
    }
  },
  clickedd: {
    background: "#f1f1f1",
    color: 'red ',
    borderRadius: 20,
    marginLeft:'auto',
    marginRight:'auto',
    '&:hover': {
      color: 'red',
      background: "#f1f1f1",
      cursor: 'pointer',
      boxShadow: '3px 3px 3px red'
    }
  }
}));



const createOption = (label) => ({
  label,
  value: label.toLowerCase(),
});






function Table({ information,options,setOptions }) {
  

  const finalSpaceCharacters = [
    {
      id: 'nine',
      name: 'Layer',
      thumb: avatar,
      value: options[8].value,
      color:options[8].color,
      numberLayers:'1'
    }
    ,
    {
      id: 'eight',
      name: 'Layer',
      thumb: avatar,
      value: options[7].value,
      color:options[7].color,
      numberLayers:'1'
    },
    {
      id: 'seven',
      name: 'Layer',
      thumb: avatar,
      value: options[6].value,
      color:options[6].color,
      numberLayers:'1'
    },
    {
      id: 'six',
      name: 'Layer',
      thumb: avatar,
      value: options[5].value,
      color:options[5].color,
      numberLayers:'1'
    },
    {
      id: 'five',
      name: 'Layer',
      thumb: avatar,
      value: options[4].value,
      color:options[4].color,
      numberLayers:'1'
    },
    {
      id: 'four',
      name: 'Layer',
      thumb: avatar,
      value: options[3].value,
      color:options[3].color,
      numberLayers:'1'
    },
    {
      id: 'three',
      name: 'Layer',
      thumb: avatar,
      value: options[2].value,
      color:options[2].color,
      numberLayers:'1'
    },
    {
      id: 'two',
      name: 'Layer',
      thumb: avatar,
      value: options[1].value,
      color:options[1].color,
      numberLayers:'1'
    },
    {
      id: 'one',
      name: 'Layer',
      thumb: avatar,
      value: options[0].value,
      color:options[0].color,
      numberLayers:'1'
    }
  ]
  const classes = useStyles();


  var [characters, updateCharacters] = useState(information[1] != null ? information[1] : finalSpaceCharacters);
  const [message, setMessage] = useState();
  // generer les id 
  const [id, setId] = useState(information[2] != null ? information[2] + 1 : 1);
  var [nb, setNb] = useState(information[0]);
  const [openParam, toggleOpenParam] = React.useState(true);


  useEffect(() => {
    for(let i = 0 ; i < characters.length ; i++)
    {var found = options.find(element => element.value === characters[i].value);
    characters[i].color=found.color}
    
    information[1] = characters
    
   
  });


  /***
   * handleOnDragEnd
   * when the drag ends, this function will be called : 
   * pour changer l'ordre des "layers"
   */


  function handleOnDragEnd(result) {
    if (!result.destination) return;
    const items = Array.from(characters);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    updateCharacters(items);
    information[1] = items
   
  }
  const add = () => {
    if(nb>10) {alert('Maximum number of Layers'); return;}   
    setId(id + 1)
    const layer = ({ id: 'id' + id, name: 'new Layer', thumb: avatar, value: options[0].value,color:options[0].color,numberLayers:1 });


    updateCharacters(characters.concat(layer));

    setNb(nb + 1)
    information[0] = nb + 1;
    information[1] = characters.concat(layer)
    information[2] = id;
  };
  const handleDelete = (index) => {
    if (window.confirm('Are you sure you wish to delete this item?')) {
      const items = Array.from(characters);
      items.splice(index, 1);
      updateCharacters(items);
      setNb(nb - 1)
      information[0] = nb - 1;

      information[1] = items
    }
  }
  function handleChangeArea(e){
    setMessage(e.target.value)
  }



  function handleChangeNumberLayer(e, id, index){
    const items = Array.from(characters);
    items[index].numberLayers = e.target.value
    updateCharacters(items);
    information[1] = items
  }



  function handleChange(e, id, index) {
   
    const items = Array.from(characters);
    items[index].value = e.value
    let x = options.find(element => element.value === e.value);
    items[index].color = x.color
    updateCharacters(items);
    information[1] = items
  }
 function handleKeyPress  (event)  {
    if(event.key === 'Enter'){
      const layer = ({ value: 'id' + id, label: 'new Layer' });
    }
  }
  return (
    <div className="App">

       
<div  className="stopwatch"  onClick={() => toggleOpenParam(!openParam)} style={{marginLeft:'60%'}} >
      <span style={{width:'120px'}} className={!openParam ?classes.clickedd:classes.delete}>     
<div > Manage Layers {!openParam ? < BarChartRoundedIcon title="a" className={classes.clickedd} onClick={() => toggleOpenParam(!openParam)} /> : < BarChartRoundedIcon title="a" className={classes.delete} onClick={() => toggleOpenParam(!openParam)} />}
</div>
</span></div>
<br/>
        {openParam?
         <div className="stopwatch" >
         <span style={{ width: "100vh", alignContent:'center',alignItems:'center',textAlign:'center',display:'inline-block' }}>
       
        <h2 className={classes.writing} >Layer placement</h2><div>The total number of layers : {nb} <AddCircleIcon title='a' className={classes.adding} onClick={add} /></div>
        
        <center>
         
                
          <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId="characters">
              {(provided) => (
                <ul className="characters" {...provided.droppableProps} ref={provided.innerRef}>
                  {characters.map(({ id, name, thumb, value,color,numberLayers }, index) => {
                    return (
                      <Draggable key={id} draggableId={id} index={index}>
                        {(provided) => (
                          <li ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                            <div className="characters-thumb" style={{backgroundColor:color , borderRadius:'50%'}}>
                              <img src={thumb} alt={`${name} Thumb`} style={{borderRadius:'50%'}} className={classes.logo_position}  />
                            </div>
                            <div className={classes.content}>
                              Position {nb - index} ,  Number of layers  <input style={{margin:'5px' , width:'30px'}} min='1' defaultValue={numberLayers} type='number' onChange={(e) => handleChangeNumberLayer(e, id, index)} ></input>
                              <Select options={options} defaultValue={{ value: value, label: value }} onChange={(e) => handleChange(e, id, index)} />
                            </div>
                            <DeleteForeverIcon title="a" className={classes.delete}  onClick={() => handleDelete(index)}/>
                          </li>
                        )}
                      </Draggable>
                    );
                  })}
                  {provided.placeholder}
                  <li className={classes.content}>
                    <div className="characters-thumb">
                      <img src={avatar} />
                    </div>
                    <p> Repair Patch </p>
                  </li>
                </ul>
              )}
            </Droppable>
          </DragDropContext>
        </center>
       
                           
        
      
      <br/><br/>
      </span></div>:<div style={{backgroundColor:'rgba(255, 0, 0, .80)',borderRadius:5,width:'100vh',marginRight:'auto',marginLeft:'auto',color:'white' }}> 
      SETTINGS
       <TableGenerator style={{width:'90%'}} title={'Labels and Colors configuration '} characters={characters} data={options} setData={setOptions} typeTable={1}></TableGenerator><br/>
       </div>
       }
      </div>
     
  );
}

export default Table;